import { observable, makeObservable } from 'mobx';

export interface IHost {
    id: string;
    hostname: string;
    ip: string;
    os: string;
    domain: string;
    architecture: string;
    completedOn: Date;
    hostId: string;
    host_id?: string;
    failed?: boolean;
    lastUpdateOn: Date;
}

export default class HostStore {
    host: IHost = {
        id: '',
        hostname: '',
        hostId: '',
        completedOn: new Date(),
        lastUpdateOn: new Date()
    };

    constructor(host: IHost) {
        makeObservable(this, {
            host: observable
        });

        this.update(host);
    }

    update(host: IHost): void {
        this.host = {
            ...this.host,
            ...host
        };
    }
}
